import React from "react";
import NotFoundImage from "../assets/404.png"; 

const NotFound = () => {
  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-white text-black px-4 text-center">
      <img
        src={NotFoundImage}
        alt="Page not found"
        className="w-72 md:w-96 mb-6"
      />
      <h1 className="text-5xl font-medium mb-4">Error 404</h1>
      <p className="text-xl mb-6 text-gray-600 max-w-md">
        We can’t seem to find the page you’re looking for.
      </p>
      <a href="/" className="text-blue-500 hover:underline">
        Go back to Home
      </a>
    </div>
  );
};

export default NotFound;
